import { c as _c } from "react/compiler-runtime";
import { useExchangeRatesQuery } from '@/api/skippay/exchangeRates';
import { SectionHeadline } from '@/components/SectionHeadline';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Loader from '@/components/Loader';
import { mergeClasses } from '@/utils/style';
import { useExchangeRateMarkupsQuery } from '@/api/skippay/exchangeRatesMarkUps';
import { Button } from '@/components/buttons';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
import dayjs from 'dayjs';
import { xmlToJson } from './exchangeRateXMLToJson';
import { DatePickerInput } from '@/components/inputs';
const currencyNamesByCode = {
  AUD: 'Australský dolar',
  CNY: 'Čínský juan',
  DKK: 'Dánská koruna',
  EUR: 'Euro',
  HUF: 'Maďarský forint',
  JPY: 'Japonský jen',
  CAD: 'Kanadský dolar',
  NOK: 'Norská koruna',
  PLN: 'Polský zlotý',
  RON: 'Rumunský nový lei',
  RUB: 'Ruský rubl',
  SEK: 'Švédská koruna',
  CHF: 'Švýcarský frank',
  TRY: 'Turecká lira',
  USD: 'Americký dolar',
  GBP: 'Britská libra'
};
function Table() {
  const $ = _c(39);
  const {
    t
  } = useTranslation("exchangeRate");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = dayjs().format("YYYY-MM-DD");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [date, setDate] = useState(t0);
  let t1;
  if ($[1] !== date) {
    t1 = {
      date
    };
    $[1] = date;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const exchangeRatesQuery = useExchangeRatesQuery(t1);
  let t2;
  if ($[3] !== date) {
    t2 = {
      date
    };
    $[3] = date;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const exchangeRateMarkupsQuery = useExchangeRateMarkupsQuery(t2);
  let t3;
  if ($[5] !== t) {
    t3 = t("exchangeRateSection.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SectionHeadline className="mb-4" anchorKey="exchangeRateSection.title">{t3}</SectionHeadline>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("exchangeRateSection.paragraph");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Text variant="p2" className="text-gray-800">{t5}</Text>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("exchangeRateSection.table.title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <strong className="text-base font-semibold lg:text-xl">{t7}</strong>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DatePickerInput defaultValue={{
      startDate: new Date(),
      endDate: new Date()
    }} maxDate={new Date()} onChange={value => {
      const date_0 = value?.startDate?.toString();
      if (date_0) {
        setDate(date_0);
      }
    }} />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8) {
    t10 = <div className="mt-12 flex flex-col items-start gap-4 lg:mt-16 lg:flex-row lg:items-center lg:justify-between">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== exchangeRatesQuery.data || $[21] !== exchangeRatesQuery.isPending || $[22] !== t) {
    t11 = exchangeRatesQuery.isPending ? <Loader /> : !exchangeRatesQuery.data ? <p className="py-6 text-center">{t("exchangeRateSection.errorLoading")}</p> : <div className="relative -mx-4 after:absolute after:top-0 after:right-0 after:block after:h-full after:w-3 sm:mx-0"><div className="relative overflow-x-auto lg:w-full"><table className={mergeClasses("seoTable", "mx-4 mt-6 mb-5 sm:mx-0 lg:mb-8 lg:text-base")}><thead><tr className="[&>th]:p-4"><th className="rounded-tr-none!">{t("exchangeRateSection.table.th.1")}</th><th>{t("exchangeRateSection.table.th.2")}</th><th>{t("exchangeRateSection.table.th.3")}</th><th className="text-center!">{t("exchangeRateSection.table.th.4")}</th><th className="rounded-tr-lg text-right!">{t("exchangeRateSection.table.th.5")}</th></tr></thead><tbody>{xmlToJson(exchangeRatesQuery.data)?.ExchangeRate?.Country?.map(_temp)}</tbody></table></div></div>;
    $[20] = exchangeRatesQuery.data;
    $[21] = exchangeRatesQuery.isPending;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== exchangeRateMarkupsQuery.data || $[25] !== t) {
    t12 = exchangeRateMarkupsQuery.data && <><Text variant="p4" className="mt-2 text-gray-600" weight="semibold">{t("exchangeRateSection.markupInfo.title")}</Text><Trans t={t} i18nKey="exchangeRateSection.markupInfo.text" components={{
        paragraph: <Text variant="p4" className="mt-2 text-gray-600" />,
        strong: <strong className="font-semibold" />,
        linkCsob: <Link to="https://www.csob.cz/lide/kurzovni-listek" testId="csobExchangeRate" analyticsParam="csobExchangeRate" />
      }} values={{
        otherCurrency: parseFloat(exchangeRateMarkupsQuery.data.otherCurrencies)
      }} /></>;
    $[24] = exchangeRateMarkupsQuery.data;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = LINKS();
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = t13.registration;
  let t15;
  if ($[28] !== t) {
    t15 = t("exchangeRateSection.button");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <Button variant="primary" align="center" to={t14} analyticsParam="exchangeRatesTableRegistration" testId="exchangeRatesTableRegistration" className="mt-12 lg:mt-16" size="lg">{t15}</Button>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t16 || $[36] !== t4 || $[37] !== t6) {
    t17 = <div className="pt-14 pb-20 lg:pt-20 lg:pb-40"><div className="mx-auto mb-12 w-full max-w-[60.5rem] text-center whitespace-normal lg:mb-16">{t4}{t6}{t10}{t11}{t12}{t16}</div></div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t16;
    $[36] = t4;
    $[37] = t6;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}
function _temp(item) {
  return <tr key={item.ID} className="[&>td]:px-4 [&>td]:py-3"><td>{item.ID}</td><td className="text-left!">{currencyNamesByCode[item.ID as keyof typeof currencyNamesByCode]}</td><td className="text-left!">{item.Country}</td><td className="text-center!">{item.quota}</td><td className="text-right! font-semibold">{item.FXcashless[0].Sale === 0 ? "" : item.FXcashless[0].Sale}</td></tr>;
}
export default Table;